<template>
    <div v-if="calendarData"
        class="lg:flex hidden items-center gap-1.5 bg-primary text-white text-xs font-medium px-2.5 py-1 rounded-full shadow-sm"
        :aria-label="`Active academic calendar: ${calendarData.session_name}${calendarData.term_name ? ' - ' + calendarData.term_name : ''}`">
        <i class="pi pi-calendar text-xs"></i>
        <span>
            {{ calendarData.session_name }}
            <span v-if="calendarData.term_name">
                • {{ calendarData.term_name }}
            </span>
        </span>
    </div>
</template>

<script setup lang="ts">
import { useAcademicCalendar } from '@/composables/queries/useAcademicCalendar';

const { activeAcademicCalendar } = useAcademicCalendar({
  activeAcademicCalendar: { autoFetch: true },
});

const { academicCalendar } = activeAcademicCalendar;

const calendarData = computed(() => {
  const cal = academicCalendar.value;
  if (!cal) return null;
  return {
    session_name: cal.session?.name || '',
    term_name: cal.termStructure?.name || '',
    total_school_days: cal.total_school_days,
    is_active: cal.is_active ? 'Yes' : 'No',
  };
});
</script>
